module.exports = __webpack_public_path__ + "img/logo_white.3e191b1a.png";